import React from "react";
import { Text } from "office-ui-fabric-react/lib/Text";
import { Link } from "office-ui-fabric-react/lib/Link";
import { titleS, subTitleS, textContainerS } from "../../../styles/detailTxt.style";

export interface OrderDetailLinkProps {
  title: string;
  url: string;
  displayText?: string;
}

const OrderDetailLink: React.FC<OrderDetailLinkProps> = ({ title, url, displayText }) => {
  return (
    url == undefined || url == "" ?
      <></> :
      <div className={textContainerS}>
        <Text styles={titleS}>{title}</Text>
        <Link 
          href={url} 
          target="_blank" 
          rel="noopener noreferrer"
          styles={subTitleS}
        >
          {displayText || url}
        </Link>
      </div>
  );
};

export default OrderDetailLink;
